<template>
  <div>
    <show-error-messages
      v-if="showErrorModal"
      :title="errorMessages.length ? 'Ошибка запроса' : 'Запрос выполнен успешно'"
      :messages="errorMessages"
      @closeErrorModal="showErrorModal = false" />
    <wrapper-preview-category customClass="section-preview_lk">
      <scan-card
        :item="item2"
        :disabled="isBlocked"
        :upload-to-serv-now="loadingFileToServer"
        :can-delete="false"
        @upload-file="uploadFile($event)"
        @replace-file="uploadFile($event)"
        id="fileId"
        :token="token"
        style="padding: 0 24px 10px 24px" />
    </wrapper-preview-category>
  </div>
</template>

<script>
  import WrapperPreviewCategory from '@/components/cards/WrapperPreviewCategory';
  import { mapGetters } from 'vuex';

  import ScanCard from '@/components/cards/scanCard';

  import ShowErrorMessages from '@/components/UI/ShowErrorMessages';
  import { saveDataInFile } from '@/API/files';

  export default {
    name: 'Exports',
    components: { ScanCard, WrapperPreviewCategory, ShowErrorMessages },
    data() {
      return {
        showMenu: false,
        loadingBlockEnterData: false,
        item2: {
          name: 'Загрузка данных',
          identifier: 'import',
          types: ['.xls', '.xlsx'],
        },
        loadingFileToServer: false,
        downloading: false,
        sprOrg: [],
        showErrorModal: false,
        errorMessages: [],
        selectedYear: '2024',
      };
    },
    computed: {
      ...mapGetters('keycloak', {
        getUserAccessToken: 'getUserAccessToken',
        getUser: 'getUser',
        getIdUser: 'getIdUser',
        token: 'getUserAccessToken',
      }),
      ...mapGetters('checkFilled', { getBlockStatus: 'getBlockStatus' }),
      ...mapGetters({ getSelectedYear: 'selectedYear' }),

      getYear() {
        if (this.getSelectedYear) return this.getSelectedYear;
        return this.selectedYear;
      },
      getOrgId() {
        if (this.getFakeUser) return this.getFakeUser.id;
        return this.getUser.orgID;
      },
      isBlocked() {
        return Object.values(this.getBlockStatus).reduce((acc, el) => {
          acc = el ? el : acc;
          return acc;
        }, false);
      },
    },
    created() {
      // this.loadSprOrg();
    },
    methods: {
      async uploadFile(event) {
        this.loadingFileToServer = true;
        try {
          const res = await saveDataInFile(event.file, this.getYear, this.getOrgId);
          if (res) {
            this.errorMessages = res.errorMessages;
          }
          this.loadingFileToServer = false;
          this.showErrorModal = true;
        } catch (e) {
          this.errorMessages = [e.message];
        }
        this.loadingFileToServer = false;
        this.showErrorModal = true;
      },
    },
  };
</script>

<style scoped>
  .list li {
    list-style-type: disc;
  }
</style>
